// API
import api from '../../api'

// Utilities
import Logger from '../../utility/loggerUtil'

export default {
  async updateMaritalData (context, maritalData) {
    try {
      await api.applicationMarital.update(
        maritalData.isMarried,
        maritalData.spousesName,
        maritalData.spousesAddress,
        context.rootState.applicationCustomer.applicationId
      )

      context.commit('updateMaritalData', {
        isMarried: maritalData.isMarried,
        spousesName: maritalData.spousesName,
        spousesAddress: maritalData.spousesAddress
      })
    } catch (error) {
      Logger.error('Error on applicationMarital/updateMaritalData')
      Logger.debug(error)
      throw error
    }
  }
}
